import { useTranslation } from 'react-i18next';
import { Bus, Plane } from 'lucide-react';

const SWATCHES = [
  { status: 'draft', className: 'bg-phx-draft-tint border-l-phx-draft' },
  { status: 'contracted', className: 'bg-phx-warning-tint border-l-phx-warning' },
  { status: 'confirmed', className: 'bg-phx-success-tint border-l-phx-success' },
  { status: 'canceled', className: 'bg-phx-danger-tint border-l-phx-danger' },
] as const;

/** Statická legenda stavů a typů dopravy pod kalendářem. */
export function CalendarLegend() {
  const { t } = useTranslation('planner');

  return (
    <div className="text-phx-xs text-phx-text-muted gap-phx-4 flex shrink-0 flex-wrap items-center">
      {SWATCHES.map(({ status, className }) => (
        <span key={status} className="gap-phx-2 flex items-center">
          <span className={`rounded-phx-sm inline-block h-3 w-4 border-l-3 ${className}`} />
          {t(`calendar.status.${status}`)}
        </span>
      ))}
      <span className="gap-phx-2 flex items-center">
        <span className="rounded-phx-sm border-phx-border-3 bg-phx-surface-2 inline-block h-3 w-4 border border-dashed" />
        {t('calendar.bar.noTransport')}
      </span>
      <span className="gap-phx-2 flex items-center">
        <Plane className="h-3 w-3" /> {t('calendar.transport.air')}
      </span>
      <span className="gap-phx-2 flex items-center">
        <Bus className="h-3 w-3" /> {t('calendar.transport.coach')}
      </span>
    </div>
  );
}
